import { Controller } from 'stimulus';
import DOMPurify from 'dompurify';

let debounce = require('lodash/debounce');

export default class extends Controller {

  static targets = ['form', "selection", "orderLink", "site", "table"]

  connect() {
    console.log(this.selectionTargets);
    this.addSelectParam();
  }

  initialize() {
    this.searchPps = debounce(this.searchPps, 250).bind(this);
    this.searchRequest = null;
  }

  searchPps(event) {
    if (this.searchRequest) {
      this.searchRequest.abort();
    }
    const query = event.target.value;
    console.log()
    this.searchRequest = $.get(`/pps.json${window.location.search ? window.location.search + '&' : "?"}query=${query}`).done(results => {
      const newRows = this.buildRows(results);
      this.tableTarget.innerHTML = newRows;
    }).fail(err => console.log(err));
  }

  // Update order_by link in table header to paginate the results corresponding to the entreprise selection
  addSelectParam() {
    const param = this.selectionTargets.find(input => input.checked).value;
    this.orderLinkTargets.forEach(link => {
      const path = link.getAttribute('href');
      link.setAttribute('href', `${path}&enterpriseSelect=${param}`);
    });
  }

  addSiteParam() {
    const param = this.siteTarget.value;
    this.orderLinkTargets.forEach(link => {
      const path = link.getAttribute('href');
      link.setAttribute('href', `${path}&site=${param}`);
    });
  }

  submitForm() {
    this.formTarget.submit();
  }

  buildRows(results) {
    console.log(results);
    return results.map(pp => {
      return `
        <tr class="js-table-row"
          tabindex="0">
          <td class="cell-data cell-data--number">
            ${DOMPurify.sanitize(pp.id)}
          </td>
          <td class="cell-data cell-data--string">
            <a href="/admin/pps/${DOMPurify.sanitize(pp.id)}" class="action-show">
              ${DOMPurify.sanitize(pp.nom)}
            </a>
          </td>
          <td class="cell-data cell-data--belongs-to">
            <a href="/admin/sites/${DOMPurify.sanitize(pp.site)}">${DOMPurify.sanitize(pp.site.name)}</a>
          </td>
          <td class="cell-data cell-data--status-field">
            ${DOMPurify.sanitize(pp.status)}
          </td>
          <td class="cell-data cell-data--belongs-to">
            ${this.buildEnterpriseCell(pp.enterprises)}
          </td>
          <td class="cell-data">
            <a class="position-absolute" href="/admin/pps/${DOMPurify.sanitize(pp.id)}">
              <img class="svg-arrow"  src="/arrow_right.svg">
            </a>
          </td>
        </tr>
      `
    }).join('');
  }

  buildEnterpriseCell(enterprises) {
    return enterprises.map(enterprise => {
      return `<a href="/admin/enterprises/${enterprise.id}">${enterprise.name}</a>`
    }).join('\n')
  }
}
